export default {
  getFreightConfiguration(state) {
    return state.freight;
  },
};
